import { Skeleton } from "antd";
import { TEducationHistory } from "features/settings/types";
import React from "react";
import { formatDate } from "admin/Authentication/hooks/useDateFormat";

const formatEducationDate = (value?: string | null) => {
  if (!value) return "";
  if (/^\d{4}$/.test(String(value).trim())) return String(value).trim();
  return formatDate(value) || value;
};

export const EducationHistory: React.FC<{
  data: TEducationHistory[];
  isLoading?: boolean;
}> = ({ data, isLoading }) => {
  return (
    <>
      {data.length > 0 && (
        <>
          <h3 className="font-semibold text-base text-gray-800 mb-4">
            Education History
          </h3>

          <Skeleton active loading={isLoading}>
            <div className="space-y-4">
              {data.map((item) => (
                <div
                  key={item.id}
                  className="bg-white border border-gray-200 rounded-xl p-5"
                >
                  <h5 className="text-sm font-semibold text-primary">
                    {item.school}
                  </h5>
                  <h4 className="text-base font-medium text-primary pt-1">
                    {item.course}
                  </h4>

                  <div className="flex items-center gap-4 text-sm text-gray-500 mt-2">
                    {item.grade && <span>{item.grade}</span>}
                    <span>
                      {formatEducationDate(item.start_date)} –{" "}
                      {item.is_current === 1
                        ? "Present"
                        : formatEducationDate(item.end_date)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </Skeleton>
        </>
      )}
    </>
  );
};
